import { environment } from '../../environments/environment';

export function isDevEnvironment(): boolean {
  return (
    environment.provider === 'fake' ||
    environment.apiBaseUrl.includes('-dev') ||
    environment.apiBaseUrl.includes('localhost')
  );
}
